import {
  RESET_GOALS,
  RESET_GOAL,
  RESET_ERROR,
  GET_GOALS,
  SET_GOALS,
  API_ERROR,
  CREATE_GOAL,
  CREATE_GOAL_SUCCESS,
  GET_GOAL,
  SET_GOAL,
  EDIT_GOAL,
  EDIT_GOAL_SUCCESS,
  DELETE_GOAL,
  DELETE_GOAL_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorGoal: false,
  loadingGoal: false,
  dataGoal: null,
  successGoal: false,
};

const Goals = (state = initialState, action) => {
  switch (action.type) {
    case RESET_GOALS:
      state = {
        ...state,
        errorGoal: false,
        loadingGoal: false,
        loadingGoalDelete: false,
        successGoal: false,
        dataGoal: null,
        dataGoalDelete: null,
      };
      break;
    case RESET_GOAL:
      state = {
        ...state,
        errorGoal: false,
        loadingGoal: false,
        successGoal: false,
        dataGoalGetSet: null,
        dataGoalEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorGoal: false,
        loadingGoal: false,
        loadingGoalEditCreate: false,
        loadingGoalActivate: false,
        successGoal: false,
      };
      break;
    case GET_GOALS:
      state = {
        ...state,
        errorGoal: false,
        loadingGoal: true,
        dataGoal: null,
      };
      break;
    case SET_GOALS:
      state = {
        ...state,
        errorGoal: false,
        loadingGoal: false,
        dataGoal: action.payload,
      };
      break;
    case CREATE_GOAL:
      state = {
        ...state,
        errorGoal: false,
        loadingGoalEditCreate: true,
        dataGoalEditCreate: action.payload,
        successGoal: false,
      };
      break;
    case CREATE_GOAL_SUCCESS:
      state = {
        ...state,
        errorGoal: false,
        loadingGoalEditCreate: false,
        dataGoalEditCreate: action.payload,
        successGoal: true,
      };
      break;
    case GET_GOAL:
      state = {
        ...state,
        errorGoal: false,
        loadingGoal: true,
        dataGoalGetSet: null,
      };
      break;
    case SET_GOAL:
      state = {
        ...state,
        errorGoal: false,
        loadingGoal: false,
        dataGoalGetSet: action.payload,
      };
      break;
    case EDIT_GOAL:
      state = {
        ...state,
        errorGoal: false,
        loadingGoalEditCreate: true,
        dataGoalEditCreate: action.payload,
        successGoal: false,
      };
      break;
    case EDIT_GOAL_SUCCESS:
      state = {
        ...state,
        errorGoal: false,
        loadingGoalEditCreate: false,
        dataGoalEditCreate: action.payload,
        successGoal: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorGoal: action.payload,
        loadingGoal: false,
        loadingGoalDelete: false,
        successGoal: false,
      };
      break;
    case DELETE_GOAL:
      state = {
        ...state,
        errorGoal: false,
        loadingGoalDelete: true,
        dataGoalDelete: action.payload,
        successGoal: false,
      };
      break;
    case DELETE_GOAL_SUCCESS:
      state = {
        ...state,
        errorGoal: false,
        loadingGoalDelete: false,
        dataGoalDelete: action.payload,
        successGoal: true,
      };
      break;
    default:
      // state = { ...state, errorGoal: false, loadingGoal: false };
      break;
  }
  return state;
};

export default Goals;
